import React, { useReducer, useEffect, useMemo } from "react"
import Todo from "./Todo"
import "./TodoList.css"
import useTodo from "./../../hooks/useTodo"
import { useLocation } from "react-router"
import { GET_SECTIONS } from "../../rest-api/queries/sections"
import { useQuery } from "@tanstack/react-query"

const TodoList = () => {
  const location = useLocation()
  const { isLoading: loading, data: sections } = useQuery(
    ["GET_SECTIONS"],
    GET_SECTIONS
  )
  const sectionId = useMemo(() => {
    return (
      sections?.find(
        (node) => node?.resourceName === location.pathname.slice(1)
      )?.id || 1
    )
  }, [sections, location])

  const { todos, deleteTodo, createTodo, updateTodo } = useTodo(sectionId)

  useEffect(() => {
    todos.refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  async function refetchTodos() {
    todos.refetch()
  }

  const remove = (id: number) => {
    deleteTodo.mutate(id)
    setTimeout(() => refetchTodos(), 0)
  }

  const update = (id: number, updatedTask: string) => {
    updateTodo.mutate({ id, textTask: updatedTask, sectionId })
    setTimeout(() => refetchTodos(), 0)
  }
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      task: "",
    }
  )

  const handleChange = (evt: any) => {
    setUserInput({ [evt.target.name]: evt.target.value })
  }

  const handleSubmit = (evt: any) => {
    if (userInput.task !== "") {
      evt.preventDefault()
      createTodo.mutate({
        textTask: userInput.task,
        sectionId,
      })
      setUserInput({ task: "" })
      setTimeout(() => refetchTodos(), 0)
    } else {
      alert("Qatorni to`ldiring!")
    }
  }

  const todosList = !loading ? (
    todos?.data?.map((node) => (
      <Todo update={update} remove={remove} key={node?.id} todo={node} />
    ))
  ) : (
    <p>Loading ...</p>
  )

  return (
    <div className="TodoList">
      <ul className="uiToDoList">{todosList}</ul>
      <form className="NewTodoForm" onSubmit={handleSubmit}>
        <input
          value={userInput.task}
          onChange={handleChange}
          id="task"
          type="text"
          name="task"
          placeholder="New Todo"
        />
        <button onClick={handleSubmit}> Add Todo</button>
      </form>
    </div>
  )
}

export default TodoList
